import React, { useState } from "react";
import Input from "../../../components/FormComponents/Input";
import Button from "../../../components/FormComponents/Button";

const CreateEntityModal = ({ createEntity, setIsModalOpen }) => {
  const [entityData, setEntityData] = useState({
    name: "",
    is_offline: false
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEntityData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleCreate = async () => {
    setIsLoading(true);
    await createEntity(entityData);
    setIsLoading(true);
    setIsModalOpen(false);
  };

  return (
    <div className="builder_form">
      <Input
        type="checkbox"
        label="Offline"
        name="is_offline"
        checked={entityData.is_offline}
        onChange={handleChange}
        containerClassName="d_flex justify_start"
      />
      <Input
        label="Entity Name"
        type="text"
        placeholder="Enter Entity Name"
        name="name"
        value={entityData.name}
        onChange={handleChange}
      />
      <Button onClick={handleCreate} isLoading={isLoading}>
        Create
      </Button>
    </div>
  );
};

export default CreateEntityModal;
